/**
 * Styles für den Footer-Brand-Block (logo-Slot des pd-footer).
 * Wird in politik-portal-app.ts in `static styles` eingehängt — der Slot-Inhalt
 * liegt im Shadow-Root der App, die Selektoren greifen direkt.
 */

import { css } from "lit";

export const footerStyles = css`
  .footer-brand-block {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    max-width: 18rem;
  }

  /*
   * Die Marke gross — sie ist der Auftritt des Hauses, der Rest ist Angabe.
   * Der Strich kommt aus dem Portal-Token: Der Fussgrund ist Petrol, dort ist
   * Papier richtig; in einem hellen Fuss waere Weiss unsichtbar.
   */
  /* Der Schriftzug traegt den Namen — entsprechend breiter als das Zeichen. */
  .footer-brand-block .marke {
    display: block;
  }

  .footer-brand-block app-pd-logo {
    --portal-marke-strich: var(--portal-papier, #fff);
    width: 13rem;
    max-width: 100%;
    height: auto;
  }

  .footer-brand-block .kennung {
    margin: 0;
  }

  .footer-brand-block .company {
    font-weight: 600;
    text-decoration: none;
  }

  .footer-brand-block address {
    font-style: normal;
    font-size: var(--portal-size-sm);
    line-height: 1.5;
    opacity: 0.9;
  }

  .footer-brand-block a {
    color: inherit;
  }
`;
